import React, { useState } from 'react';
import VECTOR from '@assets/images/renewal/vector.svg';
import Image from 'next/image';
import { cn } from '@lib/utils';

type ToolTipsProps = {
  children: React.ReactNode;
  text: React.ReactNode;
  buttonText?: string;
  url?: string;
  className?: string;
  showRedirect?: boolean;
};

const Tooltip: React.FC<ToolTipsProps> = ({
  children,
  text,
  buttonText,
  url,
  className,
  showRedirect = true,
}: ToolTipsProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const showTooltip = isHovered || isFocused;

  return (
    <div
      className={cn(
        'font-medium underline text-secondary text-xs relative mx-1',
        className
      )}
      onMouseEnter={() => setIsHovered(true)}
      onFocus={() => setIsFocused(true)}
      onMouseLeave={() => setIsHovered(false)}
      onBlur={() => setIsFocused(false)}
    >
      {children}
      {showTooltip && (
        <div className="absolute w-60 md:w-72 z-10 bottom-4 -left-4 md:-left-24 bg-gray-700 text-white rounded-md p-2 text-xs">
          {text}
          {showRedirect && (
            <button
              type="button"
              className="flex items-center w-full rounded-2xl text-center justify-center !bg-gray-500 !mt-1"
            >
              <a href={url} target="_blank" rel="noreferrer noopener">
                {buttonText}
              </a>
              <span className="w-3 ml-2">
                <Image src={VECTOR} layout="responsive" />
              </span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
